import { useState } from "react";
import { Loader2, LocateFixed, MapPinCheck } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { getCurrentPosition, reverseGeocode } from "@/lib/geo";
import { cn } from "@/lib/utils";

/**
 * GpsConsent – valfri brytar i rapportskjema: «Oppdater maskinas plassering med min posisjon».
 * Berre når teknikaren seier ja blir posisjonen sendt med rapporten (→ maskinas «sist sett»-plassering på kartet).
 * value: {lat,lng,accuracy_m} | null ; onChange(next)
 */
export const GpsConsent = ({ value, onChange, disabled, testid = "report-gps" }) => {
  const [busy, setBusy] = useState(false);
  const [address, setAddress] = useState(null);

  const toggle = async (on) => {
    if (!on) {
      onChange?.(null);
      setAddress(null);
      return;
    }
    setBusy(true);
    const pos = await getCurrentPosition();
    if (!pos) {
      setBusy(false);
      toast.error("Fekk ikkje posisjon. Gi nettlesaren tilgang til posisjon og prøv igjen.");
      return;
    }
    onChange?.(pos);
    const hit = await reverseGeocode(pos.lat, pos.lng);
    setAddress(hit?.address || null);
    setBusy(false);
  };

  return (
    <label className={cn("flex cursor-pointer items-center justify-between gap-3 rounded-lg border p-3", value && "border-primary/40 bg-primary/5")} data-testid={testid}>
      <span className="flex min-w-0 items-center gap-3 text-sm">
        {busy ? <Loader2 className="h-5 w-5 shrink-0 animate-spin text-muted-foreground" /> : value ? <MapPinCheck className="h-5 w-5 shrink-0 text-primary" /> : <LocateFixed className="h-5 w-5 shrink-0 text-muted-foreground" />}
        <span className="min-w-0">
          <span className="block font-semibold">Oppdater maskinas plassering med min posisjon</span>
          <span className="block truncate text-xs text-muted-foreground" data-testid={`${testid}-status`}>
            {value
              ? address ? `Sist sett: ${address}${value.accuracy_m ? ` (±${Math.round(value.accuracy_m)} m)` : ""}` : `Posisjon lagra${value.accuracy_m ? ` (±${Math.round(value.accuracy_m)} m)` : ""}`
              : "Valfritt. Kartet viser då maskina der du står no («sist sett»)."}
          </span>
        </span>
      </span>
      <Switch checked={!!value} onCheckedChange={toggle} disabled={disabled || busy} data-testid={`${testid}-switch`} />
    </label>
  );
};
